<template>
    <el-dialog title="" :visible="visible" :append-to-body="true" :wrapper-closable="false" @close="onCancel" width="540px"
        center>
        <div class="title">发行到...</div>
        <div class="radio-box">
            <div class="item showstart" :class="[releaseType == 1 ? 'current' : '']" @click="releaseType = 1">
                <div class="head">仅发布到秀动</div>
                <div class="desc">
                    <div>仅授权秀动使用</div>
                    <div>仅在秀动平台播放</div>
                </div>
            </div>
            <div class="item all" :class="[releaseType == 2 ? 'current' : '']" @click="releaseType = 2">
                <div class="head">全球发行</div>
                <div class="desc">
                    <div>全球平台收益</div>
                    <div>全球乐迷曝光</div>
                    <div>数万独立艺人的选择</div>
                </div>
            </div>
        </div>
        <div class="btn">
            <el-button @click="onSelect()">确认选择</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            releaseType: 1
        }
    },
    methods: {
        onCancel() {
            this.$emit('onCancel');
        },
        onSelect() {
            this.$emit('onSelect', this.releaseType);
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    border-radius: 20px !important;
}

.title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: #000000;
}

.radio-box {
    padding: 40px 25px;
    display: flex;
    justify-content: space-around;

    .item {
        height: 220px;
        width: 200px;
        padding: 50px 20px 0 20px;
        background: linear-gradient(90deg, #F5F6FA 0%, #FFFFFF 100%);
        color: #909399;
        font-size: 12px;
        font-weight: 400;
        border-radius: 10px;
        position: relative;
        transition: all 0.3s ease-in;
        cursor: pointer;
        overflow: hidden;

        // border: 2px solid transparent;
        .head {
            font-size: 18px;
            color: #000;
            font-weight: 600;
            margin-bottom: 24px;
        }

        .desc {
            position: relative;
            z-index: 2;
        }

        &::before {
            content: "";
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #EFF0F6;
            position: absolute;
            right: 20px;
            top: 20px;
            transition: all 0.3s ease-in;
        }

        &::after {
            content: "";
            position: absolute;
            width: 90px;
            height: 90px;
            right: -1px;
            bottom: -1px;
            transition: all 0.3s ease-in;
        }

        &.showstart::after {
            background: url('~@/assets/img/album/smlogo/sd_logo_no.png');
        }

        &.all::after {
            background: url('~@/assets/img/album/smlogo/sdfx_logo_no.png');
        }

        &.current {
            border: 2px solid #5914EE;
            box-shadow: 0px 10px 20px 0px rgba(89, 20, 238, 0.15);
            margin-top: -5px;

            &::before {
                background: url('~@/assets/img/album/smlogo/gou.png') #5914EE center center no-repeat;
                background-size: 50%;
            }

            &.showstart::after {
                background: url('~@/assets/img/album/smlogo/sd_logo.png');
            }

            &.all::after {
                background: url('~@/assets/img/album/smlogo/sdfx_logo.png');
            }
        }
    }
}

.btn {
    text-align: center;
    padding-bottom: 15px;

    .el-button {
        width: 106px;
        height: 40px;
        line-height: 40px;
        padding: 0;
        background: linear-gradient(315deg, #8146EE 0%, #5A14EE 100%);
        border-radius: 3px;
        color: #FFFFFF;
    }
}
</style>